import { useHandler } from "@redotech/react-util/hook";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useRef, useState } from "react";

export const SettingsMovingModal = memo(function SettingsMovingModal({
  onClose,
}: {
  onClose: (dontShowAgain: boolean) => void | Promise<void>;
}) {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const dontShowAgainRef = useRef(dontShowAgain);
  dontShowAgainRef.current = dontShowAgain;

  const handleClose = useHandler(async () => {
    await onClose(dontShowAgainRef.current);
  });

  return (
    <RedoModal
      additionalFooterContent={
        <Flex align="center" dir="row" shrink={0}>
          <RedoCheckbox
            label="Don't show this again"
            labelStyle={{ whiteSpace: "nowrap" }}
            setValue={(value) => setDontShowAgain(value === true)}
            size="sm"
            value={dontShowAgain}
          />
        </Flex>
      }
      modalSize="sm"
      onModalCloseRequested={handleClose}
      primaryButton={{ text: "Got it", onClick: handleClose, size: "sm" }}
      subtitle={
        <Flex dir="column" gap="md">
          <Text fontSize="sm" textColor="secondary">
            We've moved some settings to make things easier to find, and we'll
            be moving a few more over the coming weeks.
          </Text>
          <Text fontSize="sm" textColor="secondary">
            If you need help finding something, use the Ask Redo button and our
            AI can point you to the right setting.
          </Text>
        </Flex>
      }
      title="Settings are moving"
    />
  );
});
